'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _bdcoreUtilities = require('@bd/bdcore-utilities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SingleSelect = function (_React$Component) {
  _inherits(SingleSelect, _React$Component);

  function SingleSelect() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SingleSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SingleSelect.__proto__ || Object.getPrototypeOf(SingleSelect)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelect = function (value) {
      return function (event) {
        if (event.which && ![13, 32].includes(event.which)) {
          return;
        }

        _this.props.setFilter(value);
        _this.props.onSelect(value);
      };
    }, _this.clear = function (event) {
      if (event.which && ![13, 32].includes(event.which)) {
        return;
      }

      _this.props.setFilter(null);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SingleSelect, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          activateMenu = _props.activateMenu,
          className = _props.className,
          filter = _props.filter,
          isActiveMenu = _props.isActiveMenu,
          placeholder = _props.placeholder,
          title = _props.title,
          value = _props.value,
          values = _props.values;

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          'div',
          { className: 'FilterSelect_wrapper FilterSelect_' + filter + ' ' + (isActiveMenu('menu') ? 'FilterSelect_wrapper-active' : '') },
          _react2.default.createElement(
            'div',
            { className: 'FilterSelect_inner' },
            _react2.default.createElement(
              'span',
              {
                className: 'FilterSelect_title',
                role: 'button',
                tabIndex: '0',
                onClick: activateMenu('menu'),
                onKeyDown: activateMenu('menu')
              },
              (0, _lodash.get)(value, '[0].label', title)
            ),
            isActiveMenu('menu') && _react2.default.createElement(
              'ul',
              { className: 'FilterSelect_dropdown' },
              placeholder && _react2.default.createElement(
                'li',
                { className: 'FilterSelect_dropdownItem FilterSelect_dropdownItemPlaceholder' },
                _react2.default.createElement(
                  'span',
                  {
                    className: 'FilterSelect_dropdownItemButton',
                    role: 'button',
                    tabIndex: '0',
                    onClick: this.clear,
                    onKeyDown: this.clear
                  },
                  placeholder
                )
              ),
              values.map(function (option) {
                return _react2.default.createElement(
                  'li',
                  { key: option.label, className: 'FilterSelect_dropdownItem' },
                  _react2.default.createElement(
                    'span',
                    {
                      className: 'FilterSelect_dropdownItemButton',
                      role: 'button',
                      tabIndex: '0',
                      onClick: _this2.handleSelect(option),
                      onKeyDown: _this2.handleSelect(option)
                    },
                    option.label
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);

  return SingleSelect;
}(_react2.default.Component);

SingleSelect.propTypes = {
  activateMenu: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string,
  filter: _propTypes2.default.string.isRequired,
  isActiveMenu: _propTypes2.default.func.isRequired,
  onSelect: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  setFilter: _propTypes2.default.func.isRequired,
  title: _propTypes2.default.string,
  value: _propTypes2.default.arrayOf(_propTypes2.default.object),
  values: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
};

SingleSelect.defaultProps = {
  className: undefined,
  onSelect: function onSelect() {},
  placeholder: undefined,
  title: 'Filter',
  value: []
};

exports.default = (0, _bdcoreUtilities.menuToggler)(SingleSelect);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-filterbar/build/Filters/SingleSelect.js
// module id = 1199
// module chunks = 0